<template>
  <div>
    <a-modal
      :visible="visible"
      title="详情"
      @cancel="$emit('cancel')"
      :footer="null"
      width="1200px"
    >
      <div class="title">雨量(mm/h)</div>

      <FlowChart :list="flowList" />
      <div class="title">
        <span v-if="params.type === 'hydro_rr_tph'"> 总磷总体浓度(mg/L) </span>
        <span v-if="params.type === 'hydro_rr_nh4'"> 氨氮总体浓度(mg/L) </span>

        <span v-if="params.type === 'hydro_rr_cod'">
          化学需氧量总体浓度(mg/L)
        </span>
        <span v-if="params.type === 'hydro_ds_flow'"> 流量(m³/h) </span>
      </div>
      <WaterQualityChart :list="list" />
    </a-modal>
  </div>
</template>

<script>
import request from "@/api/request";
import WaterQualityChart from "./water-quality-chart.vue";
import FlowChart from "./flow-chart.vue";

export default {
  components: {
    WaterQualityChart,
    FlowChart,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      flowList: [],
      list: [],
    };
  },

  watch: {
    visible() {
      if (this.visible) {
        this.getData();
      }
    },
  },

  methods: {
    getData() {
      console.log("params", this.params);

      request({
        url: "/model-analysis/hydro/stat/interval",
        method: "post",
        data: {
          pid: this.params.flow ? this.params.flow.id : "",
          type: "rainfall",
        },
      }).then((res) => {
        console.log("res", res);
        if (Array.isArray(res)) {
          this.flowList = Object.freeze(res);
        }
      });

      request({
        url: "/model-analysis/hydro/stat/interval",
        method: "post",
        data: {
          ids: [this.detail.id],
          pid: this.params.pid,
          type: this.params.type,
        },
      }).then((res) => {
        console.log("res", res);
        if (Array.isArray(res)) {
          this.list = Object.freeze(res);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 1em;
}
</style>